import fetch from "../components/Fetchinterceptor/FetchInterceptor";


const branchesService = {}
const apiRoute = '/branch';

branchesService.getAll = async function (query = '') {
    try {
        const res = await fetch({
            url: `${apiRoute}/getAll/public${query}`,
            method: 'get'
        });
        return res;
    } catch (err) {
        console.log(err, 'show-err');
        return err
    }
}

branchesService.getById = async function (id) {
    try {
        const res = await fetch({
            url: `${apiRoute}/get/${id}`,
            method: 'get',
        })
        return res
    } catch (err) {
        console.log(err, 'show-err')
    }
}

branchesService.getBySlug = async function (slug) {
    try {
        const res = await fetch({
            url: `${apiRoute}/get/slug/${slug}`,
            method: 'get',
        })
        return res
    } catch (err) {
        return err
        console.log(err, 'show-err')
    }
}

export default branchesService;